import { render, staticRenderFns } from "./FactorToggle.vue?vue&type=template&id=df1b6b5a&"
import script from "./FactorToggle.vue?vue&type=script&lang=ts&"
export * from "./FactorToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports